class ClickOutsideDirective {
    constructor($document) {
        this.restrict = 'A';
        this.$document = $document;
        this.lastEventTime = 0;
    }

    link(scope, element, attrs, controllers) {
        const documentClickOutside = (e) => {
            let currentEventTime = (new Date()).getTime();
            if (currentEventTime - this.lastEventTime < 50) {
                return;
            }
            this.lastEventTime = currentEventTime;
            if (element !== e.target && !element[0].contains(e.target)) {

                if (scope.clickOutside || typeof scope.clickOutside == 'function') {
                    scope.clickOutside();
                    return;
                }

                if (scope.$parent.clickOutside || typeof scope.$parent.clickOutside == 'function') {
                    scope.$parent.clickOutside();
                    return;
                }
            }
        };

        this.$document.on('click', documentClickOutside);
        this.$document.on('mouseup', documentClickOutside);

        scope.$on('$destroy', () => {
            this.$document.off('click', documentClickOutside);
        });
    }

    static directiveFactory($document) {
        'ngInject';
        return new ClickOutsideDirective($document);
    }
}

export default ClickOutsideDirective;
